import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrTD: CultureInfo = {
  name: 'fr-TD',
  displayName: 'français (Tchad)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-TD',
  parent: CultureInfoFr
};
